export default function on(emitter, ev, fn) {
    emitter.on(ev, fn);
    return function subDestroy() {
        emitter.off(ev, fn);
    };
}
